import React from 'react';
import './Disclaimer.css';

export interface DisclaimerProps {
  text: string;
}

const Disclaimer: React.FC<DisclaimerProps> = ({ text }) => {
  return (
    <div className="disclaimer-section">
      <p className="disclaimer-text">{text}</p>
    </div>
  );
};

export default Disclaimer;

